<template>
  <a-card :bordered='false' class='p-b-80'>
    <a-tabs @change="callback" v-model:value="search.type">
      <a-tab-pane key="0" tab="全部">
      </a-tab-pane>
      <a-tab-pane key="1" tab="平台通知">
      </a-tab-pane>
      <a-tab-pane key="2" tab="微商城">
      </a-tab-pane>
      <a-tab-pane key="3" tab="互动营销">
      </a-tab-pane>
      <a-tab-pane key="4" tab="CRM">
      </a-tab-pane>
      <a-tab-pane key="5" tab="商户中心">
      </a-tab-pane>
      <a-tab-pane key="6" tab="订单">
      </a-tab-pane>
    </a-tabs>
    <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input v-model:value="search.keyword" placeholder="模版名称/内容" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click='searchTable' class='m-r-10'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-checkbox-group v-model:value="checkedList" @change="onChange" class='width100'>
      <a-spin :spinning="loading">
        <div class="list p-40 s_bor_cd9 ">
          <div class="list-item s_flex_bian width100 s_bor_b_cd9 p-b-40" v-for="(v,k) in data" :key="k">
            <span class='s_c333 fz-20'>
              <a-checkbox :value="v.id" @change="onChange">
                {{v.title}}
              </a-checkbox>
            </span>
            <span class='s_c8e'>{{v.create_time}}</span>
          </div>
          <a-empty v-if="!data.length" />
        </div>

      </a-spin>

    </a-checkbox-group>
    <div class=' s_flex_bian_c'>
      <div>
        <a-checkbox v-model:checked="checkAll" @change="onCheckAllChange">
          全选
        </a-checkbox>
        <a-button type="link" class='m-r-10' v-has:stationLetterDel='del'>删除</a-button>
      </div>
      <a-pagination :style="{marginTop:'10px'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
  </a-card>
</template>
<script>
import { getSmsSurplus, delNotice } from "@/api/message";
import { inject, reactive, ref, toRefs } from "vue";
import { getNotice } from "@/api/message";
import { iscode } from "../../../utils/app";
import { Modal } from "ant-design-vue";
const def = {
  page: 1,
  limit: 10,
  keyword: "",
  status: 1,
  type: 0,
};
export default {
  setup() {
    const state = reactive({
      loading: false,
      loadingMore: false,
      showLoadingMore: true,
      data: [],
      checkedList: [],
      checkAll: false,
      plainOptions: [],
    });
    const callback = (e) => {
      search.value.type = e;
      getData();
    };
    const _lodash = inject("_lodash");
    const search = ref({...def});
    const getData = async (callback) => {
      state.loading = true;
      let result = await getNotice(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      state.loading = false;
      state.data = result.data.data;
      state.checkedList = [];
      // 整理数据用于全选
      state.plainOptions = _lodash.map(state.data, "id");
    };
    getData();
    const searchTable = () => {
      getData();
    };
    // 单选
    const onChange = (checkedList) => {
      state.indeterminate =
        !!checkedList.length && checkedList.length < state.plainOptions.length;
      state.checkAll = checkedList.length === state.plainOptions.length;
    };
    // 全选
    const onCheckAllChange = (e) => {
      Object.assign(state, {
        checkedList: e.target.checked ? state.plainOptions : [],
      });
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      getData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      getData(search.value);
    };
    // 删除
    const del = async () => {
      if (!state.checkedList.length) return;
      Modal.confirm({
        centered: true,
        content: "确定要删除选中的站内信？",
        onOk: async () => {
          let result = await delNotice({
            id:state.checkedList.join(','),
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            getData();
          }
        },
      });
    };
    return {
      ...toRefs(state),
      getData,
      search,
      callback,
      searchTable,
      onChange,
      pageCurrentChange,
      pageSizeChange,
      onCheckAllChange,
      del,
    };
  },
};
</script>